import * as React from 'react';

export interface ILevelRightProps {
	isHidden?: boolean;
}

export default class LevelRight extends React.Component<ILevelRightProps, {}> {
	public render() {
		if (this.props.isHidden) {
			return null;
		}

		return <div className="level-right">{this.props.children}</div>;
	}
}
